var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRug = function SvgIconRug(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.858 7.736a1 1 0 0 0-1.716 0l-2.25 3.75a1 1 0 0 0 0 1.028l2.25 3.75a1 1 0 0 0 1.716 0l2.25-3.75a1 1 0 0 0 0-1.028zM12 13.806 10.916 12 12 10.194 13.084 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25 2.25a1 1 0 0 0-2 0v19.5a1 1 0 1 0 2 0V20.5h2.5v1.25a1 1 0 1 0 2 0V20.5h2.5v1.25a1 1 0 1 0 2 0V20.5h2.5v1.25a1 1 0 1 0 2 0V2.25a1 1 0 1 0-2 0V3.5h-2.5V2.25a1 1 0 1 0-2 0V3.5h-2.5V2.25a1 1 0 1 0-2 0V3.5h-2.5zm11.5 16.25v-13H6.25v13z"
  }))));
};
export default SvgIconRug;